import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    selectText: {
      ...CommonFonts.darkFont16,
    },
    selectContainer: {
      width: 150,
      marginTop: 5,
      [theme.breakpoints.down("sm")]: {
        width: 150,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .MuiInputBase-root.MuiOutlinedInput-root": {
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0,
      },
      "& .MuiInputBase-root.MuiOutlinedInput-root .MuiAutocomplete-input": {
        padding: 0,
        ...CommonFonts.darkBoldFont22,
      },
    },
  })
);

export default useStyles;
